const WORDS = ["Transparência", "Rigor", "Brilho", "Paixão", "Sem riscos", "Confiança", "Luz"];

export default function Marquee() {
  const items = [...WORDS, ...WORDS];
  return (
    <section className="relative border-y border-ink/10 bg-secondary py-8 md:py-10 overflow-hidden" data-testid="marquee">
      <div className="marquee-track items-center gap-16 md:gap-32">
        {items.map((w, i) => (
          <div key={i} className="flex items-center gap-16 md:gap-32 shrink-0">
            <span className="font-serif-ed italic text-3xl md:text-5xl text-ink/80 whitespace-nowrap">{w}</span>
            <span className="h-2 w-2 rounded-full bg-royal" />
          </div>
        ))}
      </div>
    </section>
  );
}
